// src/lib/dealStages.js
//
// The deal stage ladder — single source. Every stage list, label map and
// color map used to live inline (DealDetailPage, QuickLogModal,
// api/email-deal-intelligence, api/janet-entity-intelligence…), which is how
// adding a stage would silently miss half the readers.
//
// `terms_agreed` added 2026-08-14 (Aaron): the boundary between negotiating
// ECONOMICS and negotiating LANGUAGE deserves a stage — once material terms
// are resolved you know the next phase is papering, not counters. The close
// meter (termLedger.js) suggests the advance when every material point on
// the ledger resolves.
//
// `deal_stage` is TEXT in the DB — adding a value is code-only, but every
// list below must agree.

export const DEAL_STAGES = [
  'prospect',
  'in_negotiation',
  'terms_agreed',
  'paper_out',
  'paper_in',
  'executing',
  'active',
  'closed',
]

export const STAGE_LABELS = {
  prospect:       'Prospect',
  in_negotiation: 'In Negotiation',
  terms_agreed:   'Terms Agreed',
  paper_out:      'Paper Out',
  paper_in:       'Paper In',
  executing:      'Executing',
  active:         'Active',
  closed:         'Closed',
}

export const STAGE_COLORS = {
  prospect:        'bg-warm-200 text-warm-600 border-warm-300',
  in_negotiation:  'bg-amber-100 text-amber-700 border-amber-200',
  terms_agreed:    'bg-teal-100 text-teal-700 border-teal-200',
  paper_out:       'bg-blue-100 text-blue-700 border-blue-200',
  paper_in:        'bg-indigo-100 text-indigo-700 border-indigo-200',
  executing:       'bg-purple-100 text-purple-700 border-purple-200',
  active:          'bg-green-100 text-green-700 border-green-200',
  closed:          'bg-warm-300 text-warm-700 border-warm-400',
}

/** Stages where a deal is live in the pipeline (pre-performance). */
export const ACTIVE_DEAL_STAGES = ['in_negotiation', 'terms_agreed', 'paper_out', 'paper_in', 'executing']

/**
 * What kind of work the deal is in right now. The page changes emphasis on
 * this: negotiating → open terms dominate; papering → contracts dominate;
 * performing → obligations and payments dominate.
 */
export function stagePhase(stage) {
  if (stage === 'prospect' || stage === 'in_negotiation') return 'negotiating'
  if (stage === 'terms_agreed' || stage === 'paper_out' || stage === 'paper_in' || stage === 'executing') return 'papering'
  if (stage === 'active') return 'performing'
  if (stage === 'closed') return 'done'
  return 'negotiating'
}

export function nextStage(stage) {
  const idx = DEAL_STAGES.indexOf(stage)
  if (idx < 0 || idx >= DEAL_STAGES.length - 1) return null
  return DEAL_STAGES[idx + 1]
}
